import { Lock01 } from "@hl/base-components/lib/assets/icons/HDS";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { SeriesToken } from "@hl/shared-features/lib/apollo/graphql.generated";
import { Title, Text, Box, createStyles, Flex, Tooltip } from "@mantine/core";
import { Link } from "react-router-dom";

import { getMintPageUrl } from "~config";
import TokenOwnedBy from "~features/MintPage/TokenOwnedBy";
import TransferButton from "~features/MintPage/transfer/TransferButton";
import { ListingHighlight } from "~features/token-details/TokenDetailsCardSection1155";
import useMarketplaceState from "~features/token-details/hook/useMarketplaceState";
import useMintState from "~hooks/useMintState";

import CollectionCreatedBy from "../../MintPage/CollectionCreatedBy";

const useStyles = createStyles({
  link: {
    textDecoration: "none",
  },
});

export const LockedArborithmsToken = () => {
  return (
    <Tooltip
      label={`Non-transferable: locked by Arborithms`}
      withinPortal={true}
      sx={{ cursor: "pointer" }}
      mt={8}
    >
      <Box>
        <Lock01 color={"red"} />
      </Box>
    </Tooltip>
  );
};

const TokenDetailsTitleSection = ({ token }: { token: SeriesToken }) => {
  const { collection } = useMintState();
  const { listings, refetchToken, tokenOwnerProfile } = useMarketplaceState();

  const listing = listings?.[0] as ListingHighlight;
  const listingPrice = listing?.price;

  const { classes } = useStyles();

  if (!collection) return null;

  const lockedArborithmsToken =
    token.arborithmsTokenLockState?.isArborithms &&
    !token.arborithmsTokenLockState?.isUnlocked;

  return (
    <Box>
      <Flex justify="space-between" align="center">
        <Link className={classes.link} to={getMintPageUrl(collection)}>
          <Text size="xs" color={TEXT_COLOR.TERTIARY} tt="uppercase">
            {collection.name}
          </Text>
        </Link>
        {lockedArborithmsToken ? (
          <LockedArborithmsToken />
        ) : (
          <TransferButton
            onTransferComplete={() => refetchToken?.()}
            token={token}
            account={tokenOwnerProfile}
            listingPrice={listingPrice}
            compact
          />
        )}
      </Flex>
      <Title order={4} mt={6} lineClamp={2} display="block">
        {token.name.match(/^(#?\d+)$/)
          ? `${collection.name} ${token.name}`
          : `${token.name}`}
      </Title>
      <Flex
        sx={{
          columnGap: 8,
          rowGap: 8,
          flexWrap: "wrap",
          whiteSpace: "nowrap",
          marginTop: 10,
        }}
      >
        <CollectionCreatedBy hasCreatedByText />
        <TokenOwnedBy
          ownerAddress={token.ownerAddress ?? undefined}
          ownerEns={token.ownerEns ?? undefined}
          standard={collection.standard ?? undefined}
        />
      </Flex>
    </Box>
  );
};

export default TokenDetailsTitleSection;
